angular
  .module('pb.core.user')

  .directive('pbIsAdmin', [
    'LoggedUser',

    function(LoggedUser) {
      return {
        restrict: 'A',
        priority: 990,
        link: function(scope, element) {
          if (LoggedUser.get().isAdmin()) {
            //remove the attribute to avoid infinite loop
            element.removeAttr('pb-is-admin');
          } else {
            element.remove();
          }
        }
      };
    }
  ]);
